import { ProtocolSelectDialog } from '../../components/protocolSelectDialog.tsx';
import { Record } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    isOpen: boolean,
    onRecordCreated: (record: Record) => void,
    onClose: () => void,
}

export function MeasurementDialog({
    isOpen,
    onRecordCreated,
    onClose,
}: Props) {

    const createRecordMutation = trpc.records.createDraft.useMutation();

    const handleCreateRecord = async (protocolId: string) => {
        if (createRecordMutation.isPending) return;

        try {
            const record = await createRecordMutation.mutateAsync({
                protocolId,
                measurementType: 'ioqc',
            });
            onRecordCreated(record);
            onClose();
        } catch (err) {
            console.error(err);
            alert('Failed to create record');
        }
    };


    const pendingProtocolId = createRecordMutation.variables?.protocolId as string | undefined;

    return (
        <ProtocolSelectDialog
            isOpen={isOpen}
            pendingProtocolId={pendingProtocolId}
            onProtocolSelect={handleCreateRecord}
            onClose={onClose}
        />
    )
}
